import { flatten } from 'lodash';
import useFetchLegacyInventoryStatus from '../../../core/apiHooks/useFetchLegacyInventoryStatus';
const useLegacyInventoryStatus = (trims, shouldFetch) => {
    const allTransmissions = shouldFetch
        ? flatten(trims === null || trims === void 0 ? void 0 : trims.map(trim => {
            var _a;
            return (_a = trim === null || trim === void 0 ? void 0 : trim.transmissions) === null || _a === void 0 ? void 0 : _a.map(t => ({
                modelCode: (t === null || t === void 0 ? void 0 : t.modelCode) || '',
                transmissionKey: t === null || t === void 0 ? void 0 : t.transmissionKey,
                trimKey: trim === null || trim === void 0 ? void 0 : trim.trimKey,
            }));
        }))
        : [];
    const { data, isError, isFetching, isLoading } = useFetchLegacyInventoryStatus(allTransmissions);
    return {
        data,
        isError,
        isFetching,
        isLoading,
    };
};
export default useLegacyInventoryStatus;
